export default "__VITE_ASSET__QO40cHUX__"